<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="39" viewBox="0 0 27 39" width="27" xmlns="http://www.w3.org/2000/svg"><g :fill="color"><path d="m27 24.1307h-5.421v-5.0806h-7.1066v5.0806h-14.4355475v7.0758h14.4355475v7.7935h7.1066v-7.7935h5.421z"/><path d="m21.579 0c0 11.8683-9.6615 21.4898-21.579 21.4898v-6.9766c8.04827 0 14.5721-6.49682 14.5721-14.51184093h7.0069z"/></g></svg>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/4.vue